import { render, staticRenderFns } from "./FavoritesProductEdit.vue?vue&type=template&id=652b60a9"
import script from "./FavoritesProductEdit.vue?vue&type=script&lang=js"
export * from "./FavoritesProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports